import { DataGridTemplate } from "../../../../shared/data-grid/data-grid.template";
import { RequestDetailService } from "./detail.service";

export class PartApprovalMatrixPrintView extends DataGridTemplate {
    constructor(
        private readonly detailService: RequestDetailService,
    ) {
        super();
        this.controls.add = false;
        this.controls.edit = false;
        this.controls.delete = false;
        this.controls.excel = false;
        this.pageable = false;
        this.sortable = false;
        this.title = 'Part Approvals'

        this.detailService.requestDetail
            .subscribe(x => {
                this.refresh();
            });
    }
    columns: any[] = [
        {
            field: 'PartApprovalTitle',
            title: 'Title',
        },
        {
            field: 'PartApprovalDetails.0.Status',
            title: 'Status',
        },
        {
            field: 'PartApprovalDetails.0.PTEName',
            title: 'PTE',
        },
        {
            field: 'PartApprovalDetails.0.ReviewDate',
            title: 'Review Date'
        },
    ];

    read(opts: any): Promise<any> {
        return Promise.resolve(this.detailService.partApprovalData.value.PartApprovals);
    }
    create(parentEditDataItem: any): void {
        return null;
    }
    edit(dataItem: any): void {
        return null;
    }
    save(dataItem: any, isNew: boolean): Promise<any> {
        return Promise.resolve();
    }
    delete(dataItem: any): Promise<any> {
        return Promise.resolve();
    }
    editForm: null;
}
